import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { AuthGuard } from './auth-guard.service';

export const Approutes: Routes = [
{
  path: '',
  component: FullComponent,
  children: [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'home', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard-demo', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    canActivate: [AuthGuard],
    data : {'module':'roles'},
    path:'roles',
    loadChildren:'./roles/roles.module#RolesModule'
  },
  {
    canActivate: [AuthGuard],
    data : {'module':'users'},
    path:'users',
    loadChildren:'./users/users.module#UsersModule'
  },
  {
    path: 'dashboard-demo',
    loadChildren: './dashboards/dashboard.module#DashboardModule'
  },
  {
    canActivate: [AuthGuard],
    data : {'module':'common'},
    path: 'home',
    loadChildren: './home/home.module#HomeModule'
  },
  {
   canActivate: [AuthGuard],
   data : {'module':'settings'},
   path: 'configuration',
   loadChildren: './configuration/configuration.module#ConfigurationModule'
 },
 {
  canActivate: [AuthGuard],
  data : {'module':'auto_reports'},
  path: 'auto-reports',
  loadChildren: './auto_reports/auto_reports.module#AutoReportsModule'
  },
 {
  canActivate: [AuthGuard],
  data : {'module':'inspector'},
  path: 'inspector',
  loadChildren: './inspector/inspector.module#InspectorModule'
},
{
  canActivate: [AuthGuard],
  data : {'module':'inspector'},
  path: 'inspector-search',
  loadChildren: './inspector_search/inspector_search.module#InspectorSearchModule'
},
{
  canActivate: [AuthGuard],
  data : {'module':'vessel_group'},
  path: 'group',
  loadChildren: './group/group.module#GroupModule'
},{
  canActivate: [AuthGuard],
  data : {'module':'vessel_fleet'},
  path: 'fleet',
  loadChildren: './fleet/fleet.module#FleetModule'
},{
  canActivate: [AuthGuard],
  data : {'module':'inspection_request'},
  path: 'inspectionRequest',
  loadChildren: './inspectionRequest/inspectionRequest.module#InspectionRequestModule'
},
{
  canActivate: [AuthGuard],
  data : {'module':'inspectionPlanning'},
  path: 'inspectionPlanning',
  loadChildren: './inspectionPlanning/inspectionPlanning.module#InspectionPlanningModule'
},
{
 canActivate: [AuthGuard],
 data : {'module':'sire'},
 path: 'sire',
 loadChildren: './sire/sire.module#SireModule'
},

{
 canActivate: [AuthGuard],
 data : {'module':'sire_report'},
 path: 'sire_report',
 loadChildren: './sire_report/sire_report.module#SireReportModule'
},
{
  canActivate: [AuthGuard],
  data : {'module':'subscription',onlySuperAdmin : true},
  path: 'subscription',
  loadChildren: './subscription/subscription.module#SubscriptionModule'
},
{
  canActivate: [AuthGuard],
  data : {'module':'link_vessel',onlySuperAdmin : true},
  path: 'link_vessel/:id/:ships',
  loadChildren: './linkVessel/linkVessel.module#LinkVesselModule'
},
{
 canActivate: [AuthGuard],
 data : {'module':'sire'},
 path: 'questionnaire/:sire_id',
 loadChildren: './questionnaire/questionnaire.module#QuestionnaireModule'
},

{
  canActivate: [AuthGuard],
  data : {'module':'action_campaign'},
  path: 'action_campaign',
  loadChildren: './action_campaign/action_campaign.module#ActionCampaignModule'
},
// {
  //   canActivate: [AuthGuard],
  //   data : {'module':'oil_major'},
  //   path: 'oil-major-master',
  //   loadChildren: './oilMajorMaster/oilMajorMaster.module#OilMajorMasterModule'
  // },{
    //   canActivate: [AuthGuard],
    //   data : {'module':'ports'},
    //   path: 'port',
    //   loadChildren: './port/port.module#PortModule'
    // },
    // {
      //   canActivate: [AuthGuard],
      //   data : {'module':'template'},
      //   path: 'template',
      //   loadChildren: './template/template.module#TemplateModule'
      // },
      // {
        //   canActivate: [AuthGuard],
        //   data : {'module':'chapter'},
        //   path: 'chapter',
        //   loadChildren: './chapter/chapter.module#ChapterModule'
        // },      
        // {
          //   canActivate: [AuthGuard],
          //   data : {'module':'vessel_type'},
          //   path: 'vessel-type',
          //   loadChildren: './vessel-type/vessel-type.module#VesselTypeModule'
          // },
          // {
            //   canActivate: [AuthGuard],
            //   data : {'module':'vessel_class'},
            //   path: 'vessel-class',
            //   loadChildren: './vessel-class/vessel-class.module#VesselClassModule'
            // },
            // {
              //   canActivate: [AuthGuard],
              //   data : {'module':'vessel_flag'},
              //   path: 'vessel-flag',
              //   loadChildren: './vessel-flag/vessel-flag.module#VesselFlagModule'
              // },
              {
                canActivate: [AuthGuard],
                data : {'module':'vessel_owner'},
                path: 'vessel-owner',
                loadChildren: './vessel-owner/vessel-owner.module#VesselOwnerModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'vessel_master'},
                path: 'vessel-master',
                loadChildren: './vessel-master/vessel-master.module#VesselMasterModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'permission'},
                path: 'permission',
                loadChildren: './permission/permission.module#PermissionModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'sire'},
                path: 'observation/:reportId',
                loadChildren: './observation/observation.module#ObservationModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'sire'},
                path: 'inspectionPerOilMajor',
                loadChildren: './inspectionPerOilMajor/inspectionPerOilMajor.module#InspectionPerOilMajorModule'
              },
              {
                path: 'topTwentyObservation',
                loadChildren: './topTwentyObservation/topTwentyObservation.module#TopTwentyObservationModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'vessel_report'},
                path: 'vessel-report/:id',
                loadChildren: './vesselReport/vesselReport.module#VesselReportModule'
              },
              {
                path: 'sireHighRiskObservation',
                loadChildren: './sireHighRiskObservation/sireHighRiskObservation.module#SireHighRiskObservationModule'

              },
              {
                path: 'inspectionRisk',
                loadChildren: './inspectionRisk/inspectionRisk.module#inspectionRiskModule'
              },
              {
                path: 'pastObservationForInspector',
                loadChildren: './pastObservationForInspector/pastObservationForInspector.module#PastObservationForInspectorModule'

              },
              {
                canActivate: [AuthGuard],
                data : {'module':'vessel_owner'},
                path: 'type-of-defiency',
                loadChildren: './typeof-defiency/typeof-defiency.module#VesselOwnerModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'vessel_owner'},
                path: 'equipment-codes',
                loadChildren: './equipment-codes/equipment-codes.module#EquipmentCodesModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'vessel_owner'},
                path: 'observer-codes',
                loadChildren: './observer-codes/observer-codes.module#ObserverCodesModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'vessel_owner'},
                path: 'status-codes',
                loadChildren: './status-codes/status-codes.module#StatusCodesModule'
              },
              {
                path: 'component',
                loadChildren: './component/component.module#ComponentsModule'
              },
              { path: 'cards', loadChildren: './cards/cards.module#CardsModule' },
              { path: 'icons', loadChildren: './icons/icons.module#IconsModule' },
              { path: 'forms', loadChildren: './form/forms.module#FormModule' },
              { path: 'tables', loadChildren: './table/tables.module#TablesModule' },
              { path: 'charts', loadChildren: './charts/charts.module#ChartModule' },
              {
                path: 'widgets',
                loadChildren: './widgets/widgets.module#WidgetsModule'
              },
              { path: 'ecom', loadChildren: './ecommerce/ecom.module#EcomModule' },
              {
                path: 'timeline',
                loadChildren: './timeline/timeline.module#TimelineModule'
              },
              {
                path: 'extra-component',
                loadChildren:
                './extra-component/extra-component.module#ExtraComponentModule'
              },
              { path: 'apps', loadChildren: './apps/apps.module#AppsModule' },
              { path: 'maps', loadChildren: './maps/maps.module#MapsModule' },
              {
                path: 'sample-pages',
                loadChildren: './sample-pages/sample-pages.module#SamplePagesModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'defect_demurrage'},
                path: 'tmsa',
                loadChildren: './tmsa/tmsa.module#TmsaModule'
              },
              {
                path: 'course',
                canActivate: [AuthGuard],
                data : {'module':'course'},
                loadChildren: './course/course.module#CourseModule'
              },
              {
                path: 'training-type',
                canActivate: [AuthGuard],
                data : {'module':'training_type'},
                loadChildren: './training-type/training-type.module#TrainingTypeModule'
              },
              {
                path: 'rank',
                canActivate: [AuthGuard],
                data : {'module':'rank'},
                loadChildren: './rank/rank.module#RankModule'
              },
              {
                path: 'kpi-category',
                canActivate: [AuthGuard],
                data : {'module':'kpi_category'},
                loadChildren: './kpi-category/kpi-category.module#KpiCategoryModule'
              },
              {
                path: 'kpi-detail',
                canActivate: [AuthGuard],
                data : {'module':'kpi_detail'},
                loadChildren: './kpi-detail/kpi-detail.module#KpiDetailModule'
              },
              {
                path: 'tmsa/kpi-report',
                canActivate: [AuthGuard],
                data : {'module':'kpi_report'},
                loadChildren: './kpi-report/kpi-report.module#KPIReportModule'
              },
              {
                path: 'inspection-type',
                canActivate: [AuthGuard],
                data : {'module':'inspection-type'},
                loadChildren: './inspection-type/inspection-type.module#InspectionTypeModule'
              },
              {
                path: 'deficiency-cause',
                canActivate: [AuthGuard],
                data : {'module':'deficiency-cause'},
                loadChildren: './deficiency-cause/deficiency-cause.module#DeficiencyCauseModule'
              },
              {
                path: 'trainer-master',
                canActivate: [AuthGuard],
                data : {'module':'trainer-master'},
                loadChildren: './trainer-master/trainer-master.module#TrainerMasterModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'shore_staff_training'},
                path: 'tmsa/training',
                loadChildren: './training/training.module#TrainingModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'ship_staff_training'},
                path: 'tmsa/ship-training',
                loadChildren: './ship-training/ship-training.module#ShipTrainingModule'
              },
              {
                path: 'office-location',
                canActivate: [AuthGuard],
                data : {'module':'office_location'},
                loadChildren: './office-location/office-location.module#OfficeLocationModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'sea_farer'},
                path: 'tmsa/sea-farer',
                loadChildren: './sea-farer/sea-farer.module#SeaFarerModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'retention_rate_calculator'},
                path: 'tmsa/retention_rate_calculator',
                loadChildren: './retention_rate_calculator/retention_rate_calculator.module#RetentionRateCalculatorModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'office_audit'},
                path: 'tmsa/office-audit',
                loadChildren: './office-audit/office-audit.module#OfficeAuditModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'defect_damage_compliance'},
                path: 'tmsa/defect_damage_compliance',
                loadChildren: './defect_damage_compliance/defect_damage_compliance.module#DefectDamageComplianceModule'
              },
              {
                
                path: 'cus-design',
                loadChildren: './cus-design/cus-design.module#CusDesignModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'common'},
                path: 'dashboard',
                loadChildren: './dashboard-demo/dashboard-demo.module#DashboardDemoModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'wizard'},
                path: 'wizard',
                loadChildren: './wizard/wizard.module#WizardModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'software'},
                path: 'software',
                loadChildren: './software/software.module#SoftwareModule'
              },
              {
                canActivate: [AuthGuard],
                data : {'module':'softwareManagement'},
                path: 'tmsa/softwareManagement',
                loadChildren: './softwareManagement/softwareManagement.module#SoftwareManagementModule'
              }
              ]
            },
            {
              path: '',
              component: BlankComponent,
              children: [
              {
                path: 'authentication',
                loadChildren:
                './authentication/authentication.module#AuthenticationModule'
              },
              {
                path: '',
                loadChildren:
                './user/user.module#UserModule'
              }
              ]
            },
            {
              path: '**',
              redirectTo: '/authentication/404'
            }
            ];
